// _err_appt_not_found__resx ->
// ApptPanelError-Appt-Not-Found

export const getApptErrorKey = messageKey => {
  if (messageKey) {
    return `ApptPanelError-${messageKey
      .replace('_err_', '')
      .replace('__resx', '')
      .replace('_resx_', '')
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.substring(1))
      .join('-')}`;
  }
};
